import { Grid, Step, StepLabel, Stepper, Typography } from "@mui/material"
import { View } from "../../../components/layout/View"
import { PageType } from "../../../config/page.types"
import { useState } from "react";
import { InsertMode } from "./steps/InsertMode";
import { useForm } from "react-hook-form";
import { steps } from "./data";
import { Category } from "./steps/Category";
import { CalcType } from "./steps/CalcType";
import { useTranslation } from "react-i18next";

export type FormValues = {
    insertMode: 'manual' | 'template';
    category: 'transport' | 'consumption';
    calcType: 'greenrouter' | 'other';
}

export const Import = () => {

    const { t } = useTranslation("dataCollection");

    const form = useForm<FormValues>({
        defaultValues: {
            insertMode: undefined,
            category: undefined,
            calcType: undefined,
        }
    })

    const [activeStep, setActiveStep] = useState<number>(0);
    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    }
    const handleStepBack = (step: number) => {
        if (activeStep <= step) return;
        setActiveStep(step);
    }

    const stepper = (
        <Stepper activeStep={activeStep} alternativeLabel>
            {steps(t).map((step, index) => (
                <Step key={index} onClick={() => handleStepBack(index)} sx={{ cursor: "pointer" }}>
                    <StepLabel slotProps={{ stepIcon: { color: 'secondary' } }}>
                        {step.label}<br/>
                        <Typography variant="caption" textAlign="center" width="100%">
                            {form.getValues()[step.formKey as keyof FormValues] 
                                ? t(`import/${form.getValues()[step.formKey as keyof FormValues]}`)
                            : ''}
                        </Typography>
                    </StepLabel>
                </Step>
            ))}
        </Stepper>
    )

    return <View pageType={PageType.DataCollectionImport}>
        <Grid container spacing={2}>
            <Grid size={12}>
                {stepper}
            </Grid>
            { activeStep === 0 && <InsertMode form={form} handleNext={handleNext} /> }
            { activeStep === 1 && <Category form={form} handleNext={handleNext} /> }
            { activeStep === 2 && <CalcType form={form} handleNext={handleNext} /> }
        </Grid>
    </View>
}